import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/browser";
import App from './App';

import './styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css';
import "survey-core/survey-core.css";
import "survey-creator-core/survey-creator-core.min.css";

import { preloadTranslations } from './translation/preloadTranslations';
preloadTranslations();

// Check REACT_TYPE environment variable
const isProd = process.env.REACT_APP_TYPE && process.env.REACT_APP_TYPE === 'PROD';

if (isProd && process.env.REACT_APP_SENTRY_DSN && process.env.REACT_APP_SENTRY_DSN !== '') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.captureConsoleIntegration({
      levels: ['warn', 'error']
    })],
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  isProd ? (
    <App />
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
);
